/**
 * Pariaa Custom Sections - Vendor Loader
 * Promise-based loader for jQuery + Owl Carousel.
 * Loads each dependency only once, even if multiple sections request it
 * (e.g. on repeated Shopify section:load events in the theme editor).
 */
window.PariaaVendors = window.PariaaVendors || (function () {
  var promises = {};

  function loadScript(id, src) {
    if (promises[id]) return promises[id];
    promises[id] = new Promise(function (resolve, reject) {
      if (document.getElementById(id)) {
        resolve();
        return;
      }
      var script = document.createElement('script');
      script.id = id;
      script.src = src;
      script.onload = function () { resolve(); };
      script.onerror = function () { reject(new Error('Failed to load ' + src)); };
      document.head.appendChild(script);
    });
    return promises[id];
  }

  function loadStyle(id, href) {
    if (document.getElementById(id)) return;
    var link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function jquery() {
    if (window.jQuery) return Promise.resolve(window.jQuery);
    return loadScript(
      'pariaa-jquery',
      'https://cdnjs.cloudflare.com/ajax/libs/jquery/3.7.1/jquery.min.js'
    ).then(function () { return window.jQuery; });
  }

  function owlCarousel() {
    loadStyle(
      'pariaa-owl-css',
      'https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/assets/owl.carousel.min.css'
    );
    return jquery().then(function () {
      if (window.jQuery.fn.owlCarousel) return window.jQuery;
      return loadScript(
        'pariaa-owl-js',
        'https://cdnjs.cloudflare.com/ajax/libs/OwlCarousel2/2.3.4/owl.carousel.min.js'
      ).then(function () { return window.jQuery; });
    });
  }

  return {
    jquery: jquery,
    owlCarousel: owlCarousel
  };
})();
